import React from "react";
import { Container } from "reactstrap";

const BonusCategories = () => {
  document.title = "Casino24 - Bonus Categories";

  return (
    <Container
      fluid
      className="p-0 m-0 flex flex-col text-black w-full h-screen bg-[#eeeeee]"
    >
      {/* Header */}
      <section className="p-4 text-[3xl] w-full h-fit bg-white font-bold">
        <h2>Bonus Categories</h2>
      </section>

      {/* Form Section */}
      <section className="flex-1 p-4 justif-center items-center">
        {/* Form */}
        <section className="bg-white h-full w-full"></section>
      </section>
    </Container>
  );
};

export default BonusCategories;
